/* SNOW — theme-extra.js: keeps an open drawer's section above the page overlay */
(() => {
  'use strict';
  const timers = new WeakMap();

  const sync = (drawer) => {
    const host = drawer.closest('.shopify-section');
    if (!host) return;
    clearTimeout(timers.get(host));
    if (drawer.classList.contains('is-open')) {
      host.classList.add('has-open-drawer');
    } else {
      timers.set(host, setTimeout(() => {
        if (!host.querySelector('.drawer.is-open')) host.classList.remove('has-open-drawer');
      }, 650));
    }
  };

  const watch = (root = document) => {
    root.querySelectorAll('.drawer').forEach((drawer) => {
      if (drawer.dataset.layerWatch) return;
      drawer.dataset.layerWatch = '1';
      new MutationObserver(() => sync(drawer)).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    });
  };

  watch();
  document.addEventListener('shopify:section:load', (e) => watch(e.target));
})();

/* SNOW: delivery timeline dates on product pages */
(() => {
  'use strict';
  const addBusinessDays = (n) => {
    const d = new Date();
    let k = 0;
    while (k < n) {
      d.setDate(d.getDate() + 1);
      const w = d.getDay();
      if (w !== 0 && w !== 6) k += 1;
    }
    return d;
  };
  const fill = (root = document) => {
    root.querySelectorAll('[data-timeline]').forEach((el) => {
      const ship = Math.max(Number(el.dataset.ship) || 0, 0);
      const min = Number(el.dataset.min) || 2;
      const max = Math.max(Number(el.dataset.max) || 4, min);
      try {
        const lang = document.documentElement.lang || 'fr';
        const day = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' });
        const short = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' });
        const shipEl = el.querySelector('[data-t-ship]');
        const etaEl = el.querySelector('[data-t-eta]');
        if (shipEl) shipEl.textContent = ship === 0 ? "Aujourd'hui" : day.format(addBusinessDays(ship));
        if (etaEl) etaEl.textContent = `${short.format(addBusinessDays(ship + min))} – ${short.format(addBusinessDays(ship + max))}`;
      } catch (e) { /* keep server text */ }
    });
  };
  fill();
  document.addEventListener('shopify:section:load', (e) => fill(e.target));
})();
